<div class="app-footer">
	<span>Copyright © {{ year }} <a href="/" target="_blank">Valia</a>. All rights reserved.</span>
	<em i-bs name="heart-fill" width="13" height="13"></em>
</div>
